
import { React, ui } from "aaa";
import { ConfirmationDialog } from "../common/ConfirmationDialog";
import { TPPStore } from "./TPPStore";
import { observer } from "mobx-react";

export const TPPDetailsConfirmationDialog = observer(({ store, show, onClose }: {
    store: TPPStore;
    show: boolean,
    onClose: (revoke?: boolean) => void,
}): any => {
    return (
        <ConfirmationDialog
            show={show}
            onClose={onClose}
            title={ui.__("tpp.details.confirmation.dialog.revoke")}
            message={ui.__("tpp.details.confirmation.dialog.paragraph", { organizationName: store.currentConsent?.organizationName })}
            labelOk={ui.__("tpp.details.confirmation.dialog.button.revoke")}
        />
    );
});


// WEBPACK FOOTER //
// ./src/components/tpp/TPPDetailsConfirmationDialog.tsx